import type { ComponentProps } from 'react';

const AIStar = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_2246_217221)">
        <path
          opacity="0.4"
          d="M14.5137 6.99531L16.5 6.25L17.2453 4.26367C17.3051 4.10547 17.4562 4 17.625 4C17.7938 4 17.9449 4.10547 18.0047 4.26367L18.75 6.25L20.7363 6.99531C20.8945 7.05508 21 7.20625 21 7.375C21 7.54375 20.8945 7.69492 20.7363 7.75469L18.75 8.5L18.0047 10.4863C17.9449 10.6445 17.7938 10.75 17.625 10.75C17.4562 10.75 17.3051 10.6445 17.2453 10.4863L16.5 8.5L14.5137 7.75469C14.3555 7.69492 14.25 7.54375 14.25 7.375C14.25 7.20625 14.3555 7.05508 14.5137 6.99531Z"
          fill="currentColor"
        />
        <path
          d="M10.2105 6.57695C10.1191 6.37656 9.91875 6.25 9.70078 6.25C9.48281 6.25 9.28242 6.37656 9.19102 6.57695L7.33828 10.5883L3.32695 12.4375C3.12656 12.5289 3 12.7293 3 12.9508C3 13.1723 3.12656 13.3691 3.32695 13.4605L7.33828 15.3133L9.1875 19.3211C9.27891 19.5215 9.4793 19.648 9.69727 19.648C9.91523 19.648 10.1156 19.5215 10.207 19.3211L12.0598 15.3098L16.0711 13.457C16.2715 13.3656 16.398 13.1652 16.398 12.9473C16.398 12.7293 16.2715 12.5289 16.0711 12.4375L12.0633 10.5883L10.2105 6.57695Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2246_217221">
          <rect
            width="18"
            height="16"
            fill="white"
            transform="translate(3 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AIStar;
